import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  margin: 0;
`;
